<template>
  <a-form-item
    :ref="reference"
    :label="name"
    :name="[reference, identification, 'value']"
    :rules="{
      required: isRequired,
      message: 'País não pode ser vazio',
      trigger: 'change',
    }"
  >
    <a-select
      placeholder="Selecione"
      show-search
      option-filter-prop="children"
      :readonly="readOnlyForm"
      v-model:value="this.vForm[reference][identification].value"
      :filter-option="filterOption"
    >
      <a-select-option
        v-for="(country, index) in COUNTRIES"
        :value="index"
        :key="index"
        >{{ country }}</a-select-option
      >
    </a-select>
  </a-form-item>
</template>
<script>
import { defineComponent } from "vue";
import { mapMutations, mapState, mapGetters } from "vuex";
import { COUNTRIES } from "@/utils/Constants";

export default defineComponent({
  props: {
    reference: { type: String, required: true },
    identification: { type: Number, required: true },
    name: { type: String, required: true },
    isRequired: { type: Boolean, default: false },
  },
  data() {
    return {
      COUNTRIES,
      cValue: "BRZL",
    };
  },
  computed: {
    ...mapState("application", ["vForm"]),
    ...mapGetters("application", ["readOnlyForm"]),
  },
  methods: {
    ...mapMutations("application", ["setSaveFilledForm"]),
    filterOption(input, option) {
      return (
        option.children[0].children
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
});
</script>

<style module src="./style.scss" lang="scss"></style>
